import { render } from "./app.vue?vue&type=template&id=466d78be&ts=true"
import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/main/webapp/app/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "466d78be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('466d78be', __exports__)) {
    api.reload('466d78be', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=466d78be&ts=true", () => {
    api.rerender('466d78be', render)
  })

}


export default __exports__